import { Chip } from '@achieve/ascend'
import { AchieveLink } from 'components/AchieveLink'
import styles from './Pills.module.scss'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import classNames from 'classnames'
import { getSlug } from 'utils/conversions'
import { Typography } from 'components/Contentful'
import { mainProductConfig } from 'services/contentful/helpers'
import { LayoutContext } from 'providers/LayoutProvider'

function Pill({ category, article, pathOverride, path, id, className = '' }) {
  const router = useRouter()
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  const urlMaker = (str) => {
    const getPath = () => {
      let fullPath = router.pathname
      return fullPath.split('[')?.[0]
    }

    const queryStripper = () => {
      router.query = {}
    }

    queryStripper()
    const url = article ? pathOverride : getPath()
    return `${url}${getSlug(str)}`
  }

  const makePill = (category) => {
    return (
      <AchieveLink
        href={`${path ?? urlMaker(category)}`}
        track={{
          list_name: 'Categories',
          click_id: category,
          click_position: id,
          click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | ${category}`,
          click_type: 'Link Click',
          nav_link_section: 'Categories',
          track_event: 'page_nav_click',
          event_action: 'link_click',
          event_type: 'link_click',
        }}
      >
        <Chip
          className={classNames(styles['pill'], className)}
          data-testid="pill"
          label={<Typography variant="bodySm" content={category}></Typography>}
          color="primary"
        />
      </AchieveLink>
    )
  }

  return makePill(category)
}

export { Pill }
